import {z} from 'zod';

import i18n from '@dms/i18n';

export const EndCaseFormSchema = z.object({
  closeReasonCodeId: z.string().trim().min(1, i18n.t('general.validations.fieldIsRequired')),
  closeNote: z.string().trim().nullable().optional(),
});

export type EndCaseForm = z.infer<typeof EndCaseFormSchema>;
